import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import axios from 'axios';
import 'element-ui/lib/theme-chalk/index.css';
import VueQriously from 'vue-qriously'
import './assets/css/iconfont.css';

Vue.use(VueQriously)
Vue.use(ElementUI);
Vue.prototype.axios = axios;
Vue.config.productionTip = false;

// 读取 public/config.json 并初始化唯一的 Vue 实例
axios.get('/config.json')
  .then(response => {
    const config = response.data;
    Vue.prototype.$api = config.baseApi; // 挂载 API 地址
    initVue(); // 配置加载成功后初始化实例
  })
  .catch(error => {
    console.error('读取配置文件失败：', error);
    Vue.prototype.$api = 'http://www.viyo.me'; // 默认值
    initVue(); // 即使失败也初始化实例
  });

// 封装 Vue 实例初始化逻辑（确保只创建一次）
function initVue() {
  new Vue({
    router, // 路由配置（必须添加，否则路由失效）
    beforeCreate() {
      Vue.prototype.$bus = this; // 全局事件总线
    },
    render: h => h(App)
  }).$mount('#app');
}